"use strict";

export const tasksCode = [
    { name: "Transcriber", code: "transcriber" },
    { name: "Transcriber", code: "transcribe" },

    { name: "Translator", code: "translate" },
    { name: "Translator", code: "translator" },

    { name: "Performance Direction", code: "performancedirection" },
    { name: "Lip QA Reviewer", code: "lipqualityassurance" },
    { name: "Final QA Reviewer", code: "qualityassurance" },
    { name: "QA Reviewer", code: "performancedirectionversions" },
];

export const tasksCodeFormal = [
    { name: "Transcriber", code: "transcriber" },
    { name: "Transcribe", code: "transcribe" },

    { name: "Translate", code: "translate" },
    { name: "Translator", code: "translator" },

    { name: "Performance Direction", code: "performancedirection" },

    { name: "Attribution", code: "attribution" },
    { name: "Lip QA Review", code: "lipqualityassurance" },
    { name: "Final QA Review", code: "qualityassurance" },
    { name: "QA Review", code: "performancedirectionversions" },
];

// Video work pages slated for deprecation. Their routes stay registered so
// direct links keep working, but navigation no longer offers them.
export const hiddenVideoRoles = new Set([
    "translate",
    "translator",
    "performancedirection",
    "performancedirector",
    "qualityassurance",
    "qa",
]);

export const isVisibleVideoRole = (role) => !hiddenVideoRoles.has(role);

export const workTypes = [
    "transcribe",
    "translate",
    "performancedirection",
    "attribution",
    "lipqualityassurance",
    "qualityassurance",
    "performancedirectionversions",
].filter(isVisibleVideoRole);

export const videoAdminRoles = [
    "transcribe",
    "translate",
    "performancedirection",
    "attribution",
    "lipqualityassurance",
    "qualityassurance",
    "performancedirectionversions",
].filter(isVisibleVideoRole);

export const audioAdminRoles = ["performancedirection", "finalqa"];

export const videoRoleOrder = [
    "transcriber",
    "translator",
    "performancedirection",
    "performancedirector",
    "attribution",
    "attributioneditor",
    "lipqualityassurance",
    "lipsqa",
    "qualityassurance",
    "qa",
    "performancedirectionversions",
];

export const audioRoleOrder = [
    "performancedirection",
    "performancedirector",
    "finalqa",
    "qualityassurance",
    "qa",
];

export const roleLabels = {
    transcribe: "Transcribe",
    transcriber: "Transcribe",
    translate: "Translate",
    translator: "Translate",
    performancedirection: "Direct Performance",
    performancedirector: "Direct Performance",
    performancedirectionversions: "QA Review",
    attribution: "Edit Attribution",
    attributioneditor: "Edit Attribution",
    lipqualityassurance: "QA Lipsync",
    lipsqa: "QA Lipsync",
    qualityassurance: "QA Final",
    qa: "QA Final",
    finalqa: "QA Final",
};

export const roleEmojis = {
    transcribe: "📝",
    transcriber: "📝",
    translate: "🌐",
    translator: "🌐",
    performancedirection: "🎬",
    performancedirector: "🎬",
    performancedirectionversions: "🎞️",
    attribution: "🏷️",
    attributioneditor: "🏷️",
    lipqualityassurance: "👄",
    lipsqa: "👄",
    qualityassurance: "✅",
    qa: "✅",
    finalqa: "✅",
};

export const languageSpecificRoles = new Set([
    "translate",
    "translator",
    "performancedirection",
    "performancedirector",
    "performancedirectionversions",
    "lipqualityassurance",
    "lipsqa",
    "qualityassurance",
    "qa",
    "finalqa",
]);

